﻿import cuiMethods from './cuiMethods';
import processKeyboardEvent, { shortcutMetaKeys } from '../core/keyboardEvent';

const inputTagNames = ['INPUT', 'SELECT', 'TEXTAREA'];

export default async (control, location, options = {}) => {
	const { dataMap } = await cuiMethods.initializeCuiControl(
		control,
		location,
		{},
		options
	);
	const allShortcuts = adaptDataForControl(dataMap);
	if (allShortcuts.length === 0) {
		return;
	}

	return cuiMethods.handleControlEvents(
		control,
		['keydown'],
		options,
		(control, options, e) => {
			const isMetaKeyPressed = e.getModifierState(e.key);
			const ignoreEvent = e.repeat || isMetaKeyPressed;
			if (ignoreEvent) {
				return;
			}

			const { ctrl, alt, shift, shortcut } = processKeyboardEvent(e);
			const shortcutItem = allShortcuts.find(
				({ adaptedShortcut }) => adaptedShortcut === shortcut
			);
			if (!shortcutItem) {
				return;
			}

			let activeElement = e.target.ownerDocument.activeElement;
			while (activeElement.tagName === 'IFRAME') {
				activeElement = activeElement.contentDocument.activeElement;
			}
			const isInputElement = inputTagNames.includes(activeElement.tagName);
			const modifierPressed = ctrl || alt || shift;
			if (isInputElement && !modifierPressed) {
				return;
			}

			e.stopPropagation();
			e.preventDefault();
			e.wrappedPreventDefault?.();

			if (isInputElement) {
				activeElement.blur();
			}

			const context = {
				currentTarget: shortcutItem,
				target: shortcutItem,
				control: control
			};
			cuiMethods.executeClickMethod(shortcutItem, context, options);
		}
	);
};

const adaptDataForControl = (dataMap) => {
	return [...dataMap.values()].map((item) => {
		const keys = item.shortcut
			.replaceAll(' ', '')
			.replace('++', '+plus')
			.toLowerCase()
			.split('+');

		const key = keys.pop();
		const shortcutKeys = shortcutMetaKeys.filter((metaKey) =>
			keys.includes(metaKey)
		);
		shortcutKeys.push(key === 'plus' ? '+' : key);

		const adaptedShortcut = shortcutKeys.join('+');

		return {
			...item,
			adaptedShortcut
		};
	});
};
